module.exports = __webpack_public_path__ + "static/media/RayRedacted.19cf0318.png";